import { ApolloClient, InMemoryCache } from "@apollo/client";

import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import fetch from "cross-fetch";

export const client = new ApolloClient({
	link: createUploadLink({ uri: "http://localhost:3001/graphql", fetch }),
	cache: new InMemoryCache(),
});
